import { CommonError } from '../../types';
import {
    FETCH_NOTIFICATION_FAILURE,
    FETCH_NOTIFICATION_REQUEST,
    FETCH_NOTIFICATION_SUCCESS,
    PUSH_LIST_NOTIFICATION,
    SET_NOTIFICATION_FAILURE,
    SET_NOTIFICATION_REQUEST,
    SET_NOTIFICATION_SUCCESS,
    TOGGLE_NOTIFICATION_FAILURE,
    TOGGLE_NOTIFICATION_REQUEST,
    TOGGLE_NOTIFICATION_SUCCESS,
    UPDATE_LIST_NOTIFICATION,
} from './constants';
import { NotificationData, PriceNotificationsData } from './types';

export interface FetchNotificationRequestAction {
    type: typeof FETCH_NOTIFICATION_REQUEST;
}

export interface FetchNotificationSuccessAction {
    type: typeof FETCH_NOTIFICATION_SUCCESS;
    payload: NotificationData[];
}

export interface FetchNotificationFailureAction {
    type: typeof FETCH_NOTIFICATION_FAILURE;
    payload: any;
}

export interface UpdateListNotificationAction {
    type: typeof UPDATE_LIST_NOTIFICATION;
    payload: string;
}

export interface PushNotificationAction {
    type: typeof PUSH_LIST_NOTIFICATION;
    payload: NotificationData;
}

export interface ToggleNotificationRequest {
    type: typeof TOGGLE_NOTIFICATION_REQUEST;
}
export interface ToggleNotificationSuccess {
    type: typeof TOGGLE_NOTIFICATION_SUCCESS;
}

export interface ToggleNotificationFailure {
    type: typeof TOGGLE_NOTIFICATION_FAILURE;
}

export interface SetNotificationRequest {
    type: typeof SET_NOTIFICATION_REQUEST;
    payload: PriceNotificationsData[]
}
export interface SetNotificationSuccess {
    type: typeof SET_NOTIFICATION_SUCCESS;
}

export interface SetNotificationFailure {
    type: typeof SET_NOTIFICATION_FAILURE;
}


export type NotificationActions =
    | FetchNotificationRequestAction
    | FetchNotificationSuccessAction
    | FetchNotificationFailureAction
    | UpdateListNotificationAction
    | PushNotificationAction
    | ToggleNotificationRequest
    | ToggleNotificationSuccess
    | ToggleNotificationFailure
    | SetNotificationRequest
    | SetNotificationSuccess
    | SetNotificationFailure;

export const fetchNotificationRequest = (): FetchNotificationRequestAction => ({
    type: FETCH_NOTIFICATION_REQUEST,
});

export const fetchNotificationSuccess = (payload: NotificationData[]): FetchNotificationSuccessAction => ({
    type: FETCH_NOTIFICATION_SUCCESS,
    payload,
});

export const fetchNotificationFailure = (error: CommonError): FetchNotificationFailureAction => ({
    type: FETCH_NOTIFICATION_FAILURE,
    payload: error,
});

export const updateListNotification = (id: string): UpdateListNotificationAction => ({
    type: UPDATE_LIST_NOTIFICATION,
    payload: id,
});
export const pushListNotification = (data: NotificationData): PushNotificationAction => ({
    type: PUSH_LIST_NOTIFICATION,
    payload: data,
});

export const fetchToggleNotificationRequest = (): ToggleNotificationRequest => ({
    type: TOGGLE_NOTIFICATION_REQUEST,
});

export const fetchToggleNotificationSuccess = (): ToggleNotificationSuccess => ({
    type: TOGGLE_NOTIFICATION_SUCCESS,
});

export const fetchToggleNotificationFailure = (): ToggleNotificationFailure => ({
    type: TOGGLE_NOTIFICATION_FAILURE,
});

export const fetchSetNotificationRequest = (payload: PriceNotificationsData[]): SetNotificationRequest => ({
    type: SET_NOTIFICATION_REQUEST,
    payload,
});

export const fetchSetNotificationSuccess = (): SetNotificationSuccess => ({
    type: SET_NOTIFICATION_SUCCESS,
});

export const fetchSetNotificationFailure = (): SetNotificationFailure => ({
    type: SET_NOTIFICATION_FAILURE,
});

